import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import quizBg from "../Assets/img/misc/quiz-bg.png";
import banner from "../Assets/img/tcs_dashboard.png";
import style from "../Assets/css/b2bCarouselMain.module.css";

function MyCourseCarousel() {
	const [index, setIndex] = useState(0);

	const handleSelect = (selectedIndex, e) => {
		setIndex(0);
	};

	const styles = {
		text: {
			margin: "30%",
		},
	};

	return (
		<div>
			<Carousel
				// className={`${style["carousel-indicators"] ${style.active}`}
				className={`${style["carousel-indicators"]} ${style.active}`}
				style={{ zIndex: "0" }}
				controls={false}
				prevIcon={
					<span
						aria-hidden="false"
						className="carousel-control-prev-icon"
					/>
				}
				activeIndex={index}
				onSelect={handleSelect}
				slide="true"
			>
				<Carousel.Item interval={1000}>
					{/* <div  styles={{ backgroundImage:`url(${car})` }}> */}

					<img
						style={{ height: "30vw" }}
						className="d-block w-100"
						src={banner}
						alt="First slide"
						usemap="#image-map"
					/>

					<map name="image-map">
						<area
							target="_blank"
							alt="Instagram"
							title="Instagram"
							href="https://instagram.com/cantilever_labs?utm_medium=copy_link"
							coords="419,197,97,137"
							shape="rect"
						/>
						<area
							target="_blank"
							alt="Discord"
							title="Discord"
							href="http://discord.gg/zK8WZwx92J"
							coords="1,0,1079,398"
							shape="rect"
						/>
					</map>

					<Carousel.Caption style={{ color: "white" }}>
						{/* <h3 style={styles.text}>First</h3> */}
						{/* <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item interval={1000}>
					<img
						style={{ height: "30vw" }}
						className="d-block w-100"
						src={banner}
						alt="First slide"
						usemap="#image-map"
					/>

					<map name="image-map">
						<area
							target="_blank"
							alt="Instagram"
							title="Instagram"
							href="https://instagram.com/cantilever_labs?utm_medium=copy_link"
							coords="419,197,97,137"
							shape="rect"
						/>
						<area
							target="_blank"
							alt="Discord"
							title="Discord"
							href="http://discord.gg/zK8WZwx92J"
							coords="1,0,1079,398"
							shape="rect"
						/>
					</map>

					<Carousel.Caption>
						{/* <h3 style={styles.text}>Second</h3> */}
						{/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
					</Carousel.Caption>
				</Carousel.Item>
				<Carousel.Item interval={1000}>
					<img
						style={{ height: "30vw" }}
						className="d-block w-100"
						src={banner}
						alt="First slide"
						usemap="#image-map"
					/>

					<map name="image-map">
						<area
							target="_blank"
							alt="Instagram"
							title="Instagram"
							href="https://instagram.com/cantilever_labs?utm_medium=copy_link"
							coords="419,197,97,137"
							shape="rect"
						/>
						<area
							target="_blank"
							alt="Discord"
							title="Discord"
							href="http://discord.gg/zK8WZwx92J"
							coords="1,0,1079,398"
							shape="rect"
						/>
					</map>

					<Carousel.Caption>
						<h3 style={styles.text}>Third</h3>
						<p>
							{/* Praesent commodo cursus magna, vel scelerisque nisl consectetur. */}
						</p>
					</Carousel.Caption>
				</Carousel.Item>
			</Carousel>
		</div>
	);
}

export default MyCourseCarousel;
